import GradeFeeCreate from "@/controllers/grade_fee/grade-fee-create.js";
import axios from "axios";
import { required, numeric } from "vuelidate/lib/validators";

export default {
    extends: GradeFeeCreate,
    data() {
        return {
            academic_year: 0,
            campus_grade_id: 0,
            academicYearArr: [],
            gradeArr: [],
            gradeFeeData: {
                annual_fee: "",
                monthly_fee: "",
                termly_fee: ""
            },
        };
    },

    validations: {
        academic_year: {
            required
        },
        campus_grade_id: {
            required
        },
        gradeFeeData: {
            annual_fee: {
                numeric
            },
            monthly_fee: {
                numeric
            },
            termly_fee: {
                numeric
            },
            atLeastOneFee: {
                validator() {
                    return this.atLeastOneFee();
                }
            }
        },
    },

    methods: {
        getCampusGradeName() {
            this.getAcademicYears();
        },

        getAcademicYears() {
            axios.get("period/periodList")
                .then((res) => {
                    const defaultOption = [{ id: 0, text: "Select Academic Year" }];
                    this.academicYearArr = defaultOption.concat(res.data.data || []);
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.academicYearArr = [{ id: 0, text: "Select Academic Year" }];
                    this.isLoading = false;
                });
        },

        getGradeList(yearId) {
            const defaultOption = [{ id: 0, text: "Select Grade" }];
            this.gradeArr = defaultOption;
            this.campus_grade_id = 0;

            if (!yearId || Number(yearId) === 0) {
                return;
            }

            axios.get("campusGrade/list-by-acdYear", {
                params: {
                    campus_id: this.$store.state.user.campus_id,
                    acd_year_id: yearId,
                    get_grade: true,
                }
            }).then((res) => {
                const rows = Array.isArray(res.data) ? res.data : [];
                this.gradeArr = defaultOption.concat(rows.map((grade) => ({
                    id: grade.campus_grade_id,
                    text: grade.grade_name
                })));
            }).catch((error) => {
                if (error.response && error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
            });
        },

        atLeastOneFee() {
            return (
                !!this.gradeFeeData.annual_fee ||
                !!this.gradeFeeData.monthly_fee ||
                !!this.gradeFeeData.termly_fee
            )
        },

        changeEvent(val, fieldName) {
            this.$set(this, fieldName, val);

            if (fieldName === 'academic_year') {
                this.submitted = false;
                this.getGradeList(val);
            }
        },

        selectEvent({ id }, fieldName) {
            id == 'Select' ? this.$set(this, fieldName, '') : this.$set(this, fieldName, id);
        },

        confirmRegister() {
            if (this.disabled) return;
            this.submitted = true;
            if (
                this.$v.$invalid ||
                this.academic_year == '' ||
                this.academic_year == 0 ||
                this.campus_grade_id == '' ||
                this.campus_grade_id == 0
            ) {
                return;
            }
            this.register();
        },

        register() {
            this.disabled = true;
            var request = {
                campus_grade_id: this.campus_grade_id,
                monthly_fee: this.gradeFeeData.monthly_fee,
                annual_fee: this.gradeFeeData.annual_fee,
                termly_fee: this.gradeFeeData.termly_fee,
            }

            axios.post("/gradeFee/create", request, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    if (response.data.status == 200) {
                        this.$notification.success("Grade Fee Added Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        if (this.$route.query.rd_back == 'student') {
                            this.$router.push({
                                name: "gradeFeeCreate"
                            });
                        } else {
                            this.$router.push({
                                name: "gradeFeeList"
                            });
                        }
                    } else {
                        this.disabled = false;
                        this.$notification.error(response.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    if (error.response.status == 422) {
                        this.disabled = false;
                        this.$notification.error(error.response.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                    this.disabled = false;
                    console.log("Grade Fee Create API Error:", error.response.data.message);
                });
        },
    },

    mounted() {
        this.isLoading = true;
    },
};
